module.exports = __webpack_public_path__ + "static/media/CienciasOp.6b01f7a9.png";